<template>
  <div>
    <modal class="block cursor-pointer select-none" title="Contenido del archivo de protocolo de texto completo"
           id="pdf-modal"
           big
           :ok-callback="showModal">
      <p class="alert alert-info">Requisitos que debe contener el protocolo de acuerdo a los lineamientos
                                  internos.</p>
      <ol style="list-style-type: lower-alpha" id="protocol-file-modal">
        <li
          class="block cursor-pointer select-none" title="Debe identificar el objeto del estudio o intervención. El título debe ser corto, preciso, conciso y acorde al contenido de la investigación propuesta">
          Título
        </li>
        <li>Versión y fecha de versión</li>
        <li
          class="block cursor-pointer select-none" title="Responsable, participantes del estudio y centro de adscripción. (Deben coincidir con los registrados en el SIID)">
          Portada
        </li>
        <li
          class="block cursor-pointer select-none" title="Con una extensión máxima de 250 palabras. El resumen debe contener los aspectos más relevantes del proyecto (problema de investigación, hipótesis u objetivos planteados, metodología, plan de análisis y productos esperados)">
          Resumen estructurado
        </li>
        <li
          class="block cursor-pointer select-none" title="Que incluya antecedentes y estado del arte, pregunta de investigación, marco teórico/conceptual de la investigación, hipótesis de investigación (en su caso) y justificación">
          Introducción
        </li>
        <li
          class="block cursor-pointer select-none" title="Especificar la finalidad del estudio y delimitar el problema por investigar. De ser posible, delimitarlos por general y específico">
          Objetivos
        </li>
        <li data-html="true"
            class="block cursor-pointer select-none" title="Describir el diseño del estudio, tamaño de muestra y muestreo si es el caso, criterios de selección (inclusión, exclusión y eliminación cuando proceda, recolección, fuentes e instrumentos para la obtención de la información, operacionalización de las principales variables a estudiar y estrategias de análisis. Cuando sea posible, el estudio se delimitará espacial y temporalmente. En su caso, identificar si este documento describe solamente un estudio piloto como tal, o si se llevará al cabo un estudio piloto como parte preliminar de un proyecto de investigación que se desarrolla íntegramente en el documento">
          Metodología
        </li>
        <li
          class="block cursor-pointer select-none" title="Los autores deberán exponer la problemática que anticipan en el desarrollo de su proyecto y las limitaciones del  mismo">
          Problemas y limitaciones
        </li>
        <li data-html="true" class="block cursor-pointer select-none" title="<p>Recursos necesarios, cooperación requerida de otras instancias y, si ya existe, financiamiento externo;
En caso de no contar con el convenio firmado al momento de la evaluación, deberá adjuntar una carta en la que se comprometan a incorporarlo una vez que se concluya el proceso de firmas. La carta deberá contener la siguiente información:</p>

<ul class='text-left'>
<li>Agencia financiadora</li>
<li>Monto</li>
<li>Compromisos</li></ul>

<strong>En caso de que el proyecto no cuente con financimiento, deberá especificar cómo se llevará a cabo.</strong>">
          Financiamiento
        </li>
        <li
          class="block cursor-pointer select-none" title="En el cronograma los autores deberán describir el plan de trabajo a seguir de acuerdo al tiempo establecido en el protocolo, especificando los procedimientos a realizar para el desarrollo de la investigación">
          Cronograma de actividades
        </li>
        <li
          class="block cursor-pointer select-none" title="Todo lo relativo a las condicines de participación  de los sujetos de estudio de acuerdo a los requisitos establecidos en los Lineamientos del Comité de Ética en Investigación">
          Aspectos éticos
        </li>
        <li
          class="block cursor-pointer select-none" title="Información relativa a  la integridad física-biológica del personal ocupacionalmente expuesto, así como los sujetos de investigación, la comunidad y el medio ambiente">
          Aspectos de bioseguridad
        </li>
        <li class="block cursor-pointer select-none" title="Contribución principal del proyecto al estado del arte sobre el tema de estudio">Aspectos esperados
        </li>
        <li class="block cursor-pointer select-none" title="Literatura consultada que sustenta directamente el estudio">Referencias bibliográficas</li>
        <li
          class="block cursor-pointer select-none" title="Información o aclaraciones necesarias para completar el texto del protocolo, pero que debido a su extensión o naturaleza no se consideran convenientes para incluirlas dentro del mismo">
          Anexos
        </li>
      </ol>
    </modal>
  </div>
</template>

<script>
  import Modal from '../ui/Modal'
  import $ from 'jquery'
  
  export default {
    name: 'ProtocolFileRequirements',
    components: {
      Modal,
    },
    methods: {
      showModal() {
        $('#pdf-modal').modal('hide')
  
        this.fileModalType = 'single'
  
        $('#file-modal').modal({
          backdrop: 'static',
          keyboard: false,
        })
      },
    },
    mounted () {
      $(this.$el).find('li').hover(function (e) {
        const link = $(this)
    
        if(link.attr('title')) {
          link.tooltip({
            title: link.attr('title'),
            placement: 'top',
          })
      
          link.tooltip('show')
        }
      }).tooltip('show')
    }
  }
</script>

<style lang="scss" scoped>
ul {
  li {
    cursor: pointer;
    user-select: none;
  }
}

.tooltip-inner {
  max-width: 90% !important;
}
</style>
